import { createSlice } from '@reduxjs/toolkit';
import { func_cookie, getObjectPropertyValue, isStringTrimEmpty } from 'functions';

export const authenticationSlice = createSlice({
	name: 'authentication',
	initialState: {},
	reducers: {
		// Login
        login_request: (state) => {
			state.login_requesting = true;
			state.login_status = false;
            state.isLoggedIn = undefined;
            state.userInfo = undefined;
            state.login_errorMsg = undefined;
		},
        login_success: (state, action) => {
            // Set token in cookie
            let isEveryTokenSetSuccessfully = setTokens(action);

            // Monitor refresh token validity
            state.monitorTokenInterval = setInterval(() => { 
                let refreshToken = func_cookie.getCookieValue("refresh_token_bp");
                if (isStringTrimEmpty(refreshToken)) {
                    clearInterval(state.monitorTokenInterval);
                }
            }, 3000);
            
			state.login_requesting = false;
			state.login_status = true;
            
            state.isLoggedIn = isEveryTokenSetSuccessfully;
            state.login_errorMsg = undefined;
		},
        login_failure: (state, action) => {
			state.login_requesting = false;
			state.login_status = false;
            state.isLoggedIn = false;
            state.login_errorMsg = action?.payload?.data?.exceptionMessage;
		},


        // Refresh Access Token
        refreshAccessToken_request: (state) => {
			state.refreshAccessToken_requesting = true;
			state.refreshAccessToken_status = false;
            state.refreshAccessToken_errorMsg = undefined;
		},
        refreshAccessToken_success: (state, action) => {
            // Set token in cookie
            setTokens(action);

            state.refreshAccessToken_requesting = false;
            state.refreshAccessToken_status = true;
            state.refreshAccessToken_errorMsg = undefined;
        },
        refreshAccessToken_failure: (state, action) => {
            state.refreshAccessToken_requesting = false;
            state.refreshAccessToken_status = false;
            state.refreshAccessToken_errorMsg = action?.payload?.data?.exceptionMessage;
        },


        // Generate Email OTP
        generateEmailOTP_request: (state) => {
            state.generateEmailOTP_requesting = true;
            state.generateEmailOTP_status = false;
            state.generateEmailOTP_errorMsg = undefined;
        },
        generateEmailOTP_success: (state, action) => {
            state.generateEmailOTP_requesting = false;
            state.generateEmailOTP_status = true;
            state.generateEmailOTP_errorMsg = undefined;
        },
        generateEmailOTP_failure: (state, action) => {
            state.generateEmailOTP_requesting = false;
            state.generateEmailOTP_status = false;
            state.generateEmailOTP_errorMsg = action?.payload;
        },


        // Reset Password
        resetPassword_request: (state) => {
            state.resetPassword_requesting = true;
            state.resetPassword_status = false;
            state.resetPassword_errorMsg = undefined;
        },
        resetPassword_success: (state, action) => {
            state.resetPassword_requesting = false;
            state.resetPassword_status = true;
            state.resetPassword_errorMsg = undefined;
        },
        resetPassword_failure: (state, action) => {
            state.resetPassword_requesting = false;
            state.resetPassword_status = false;
            state.resetPassword_errorMsg = action?.payload;
        },


        // Logout
        logout_request: (state) => {
            state.logout_requesting = true;
            state.logout_status = false;
        },
        logout_success: (state) => {
            clearInterval(state.monitorTokenInterval);
            func_cookie.removeCookie("access_token_bp", { path: "/" });
            func_cookie.removeCookie("refresh_token_bp", { path: "/" });

            state.logout_requesting = false;
            state.logout_status = true;
            state.userInfo = undefined;
            state.isLoggedIn = false;
        },
        logout_failure: (state) => {
            state.logout_requesting = false;
            state.logout_status = false;
        },


        // Get Login Info
        getUserInfo_request: (state) => {
            state.getUserInfo_requesting = true;
            state.getUserInfo_status = false;
            state.getUserInfo_errorMsg = undefined;
        },
        getUserInfo_success: (state, action) => {
            state.getUserInfo_requesting = false;
            state.getUserInfo_status = true;
            state.userInfo = action?.payload?.data;
            state.getUserInfo_errorMsg = false;
        },
        getUserInfo_failure: (state, action) => {
            state.getUserInfo_requesting = false;
            state.getUserInfo_status = false;
            state.getUserInfo_errorMsg = action?.payload;
        },


        // Login Modal Visiblity
        loginModalVisiblity: (state, action) => {
            state.isLoginModalVisible = action?.payload?.isModalVisible;
        }
	},
});

function setTokens(action) {
    let response = action?.payload?.data;

    let access_token = getObjectPropertyValue(response, "access_token");
    let access_token_expirationDate = getObjectPropertyValue(response, "access_token_expires");
    let options = { 
        path: '/',
        sameSite: "strict",
        expires: new Date(access_token_expirationDate),
    };
    let isSetSuccessfully_accessToken = func_cookie.setCookie("access_token_bp", access_token, options);

    let refresh_token = getObjectPropertyValue(response, "refresh_token");
    let refresh_token_expirationDate = getObjectPropertyValue(response, "refresh_token_expires");
    options = { 
        path: '/',
        sameSite: "strict",
        expires: new Date(refresh_token_expirationDate),
    };
    let isSetSuccessfully_refreshToken = func_cookie.setCookie("refresh_token_bp", refresh_token, options);

    let isEveryTokenSetSuccessfully = isSetSuccessfully_accessToken && isSetSuccessfully_refreshToken;
    return isEveryTokenSetSuccessfully;
}


export const { 
	login_request, login_success, login_failure,
    refreshAccessToken_request, refreshAccessToken_success, refreshAccessToken_failure,
    generateEmailOTP_request, generateEmailOTP_success, generateEmailOTP_failure,
    resetPassword_request, resetPassword_success, resetPassword_failure,
    logout_request, logout_success, logout_failure,
    getUserInfo_request, getUserInfo_success, getUserInfo_failure,
    loginModalVisiblity
} = authenticationSlice.actions;

export default authenticationSlice.reducer;